import _d from '@repperjs/debug';
import { setupPaddle } from '@repperjs/shared/src/services/paddle/index.js';
import { createBrowserHistory } from 'history';
// import pointer events
import 'pepjs';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { featureCheck } from '@repperjs/shared/src/utils/gl/featureCheck.js';
import './logging.js';
import { unregister } from './registerServiceWorker.js';
import { getRoutes } from './state/index.ts';
import { createStore } from './store/createStore.js';
import './styles/core.css';
import AppContainer from './containers/AppContainer.js';

/* eslint-disable no-unused-vars */
const log = _d('repper:index'),
    error = _d('repper:error'),
    warn = _d('repper:warning');
/* eslint-enable no-unused-vars */

// log version & build date
log(
    `version: ${process.env.PUBLIC_APP_VERSION}-${process.env.PUBLIC_GIT_REV} (build date: ${process.env.PUBLIC_BUILD_DATE})`,
);

// setup paddle
setupPaddle();

// do a feature check
if (featureCheck()) {
    // start the app!
    run();
} else {
    error('Repper does not have the necessary features to run.');
}

async function run() {
    // ========================================================
    // Store Instantiation
    // ========================================================
    const history = createBrowserHistory();
    // @ts-ignore
    const initialState = window.___INITIAL_STATE__;

    const routes = await getRoutes();

    const store = createStore(initialState, history, routes);

    // ========================================================
    // Render Setup
    // ========================================================
    const MOUNT_NODE = document.getElementById('root');
    if (!MOUNT_NODE) {
        throw new Error('Mount node not found');
    }

    let render = () => {
        const root = createRoot(MOUNT_NODE);
        root.render(<AppContainer store={store} routes={routes} history={history} />);
    };

    // ========================================================
    // Go!
    // ========================================================

    render();
    //registerServiceWorker();
    unregister();
}
